import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { PhysiciansQuery, PhysiciansQueryVariables } from '@/shared/api';
import PHYSICIANS_QUERY from '../queries/physicians';

/**
 * Retrieves the physicians available to the current facility scope using the supplied filter. Runs PHYSICIANS_QUERY on a fresh Apollo client and throws the first GraphQL error message when the physicians payload comes back nil.
 *
 * @param filter - Filter criteria forwarded to the GraphQL query.
 * @param limit - Maximum number of records to return, defaulting to 1000.
 * @returns The physicians collection returned by the query.
 */
const fetchPhysicians = async (
  filter: PhysiciansQueryVariables['filter'],
  limit: number = 1000,
): Promise<PhysiciansQuery['physicians']> => {
  const client = createClient();
  const physiciansResult = await client.query<PhysiciansQuery, PhysiciansQueryVariables>({
    query: PHYSICIANS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = physiciansResult;
  const { physicians } = data;
  if (_.isNil(physicians) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return physicians;
};

export default fetchPhysicians;
